import script from "./ESportCouponsCompetitions.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportCouponsCompetitions.vue?vue&type=script&setup=true&lang=js"

import "./ESportCouponsCompetitions.vue?vue&type=style&index=0&id=3a234e78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a234e78"]])

export default __exports__